module.exports = __webpack_public_path__ + "img/8_people.b5746eed.jpg";